import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AiSettingsService, AIModelProvider } from '../../../services/ai-settings.service';

export interface HomepageUser {
  name: string;
  role: string;
  avatar: string;
}

@Component({
  selector: 'app-homepage-header',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './homepage-header.component.html',
  styleUrls: ['./homepage-header.component.scss']
})
export class HomepageHeaderComponent {
  @Input() logoSrc: string = 'logos/clients/i-o.svg';
  @Input() user!: HomepageUser;
  @Input() basePath: string = '';
  @Input() profiles: HomepageUser[] = [];
  @Output() profileChange = new EventEmitter<HomepageUser>();

  isSettingsModalOpen = false;
  selectedModelProvider: AIModelProvider;

  constructor(private aiSettings: AiSettingsService) {
    this.selectedModelProvider = this.aiSettings.modelProvider;
  }

  get homeHref(): string {
    return this.basePath ? `/` : '/';
  }

  get otherProfiles(): HomepageUser[] {
    return this.profiles.filter(p => p.name !== this.user.name);
  }

  get isAaronProfile(): boolean {
    return this.user?.name?.toLowerCase() === 'aaron';
  }

  resetDemoData(): void {
    if (typeof window !== 'undefined' && window.localStorage) {
      window.localStorage.clear();
      window.location.reload();
    }
  }

  switchProfile(profile: HomepageUser): void {
    this.profileChange.emit(profile);
  }

  openSettingsModal(): void {
    this.selectedModelProvider = this.aiSettings.modelProvider;
    this.isSettingsModalOpen = true;
  }

  closeSettingsModal(): void {
    this.isSettingsModalOpen = false;
  }

  saveSettings(): void {
    this.aiSettings.setModelProvider(this.selectedModelProvider);
    this.closeSettingsModal();
  }

  onModelChange(provider: AIModelProvider): void {
    this.selectedModelProvider = provider;
  }

  onAvatarError(event: Event): void {
    const img = event.target as HTMLImageElement;
    const failedSrc = img.src;
    const defaultAvatarPath = 'user-avatars/default.png';

    // Prevent infinite loop if default avatar also fails
    if (failedSrc.endsWith(defaultAvatarPath)) {
      console.warn('[HomepageHeader] Default avatar also failed to load');
      return;
    }

    console.log('[HomepageHeader] Avatar failed to load:', failedSrc);
    console.log('[HomepageHeader] Falling back to default avatar');
    // Use basePath to ensure correct resolution when embedded
    img.src = this.basePath ? `${this.basePath}${defaultAvatarPath}` : defaultAvatarPath;
  }
}
